import "./App.css";

import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Dashboard from "./pages/dashboard";
// import SubCategory from 'pages/subCategory'
import AddCartDetails from "pages/addCartDetails";
import ProductDetails from "pages/productDetails";
import OrderDetails from "pages/orderDetails";
import HotOffer from "pages/hotOffer";
import ConfirmOrder from "pages/confirmOrder";
import CategoryWiseData from "pages/categoryWiseData";
import SubCategoryWiseData from "pages/subCategoryWiseData";
import NewProductsFullPage from "pages/newProductsFullPage";
import TrendingProductsFullPage from "pages/TrendingProductsFullPage";
import FreeDeliveryFullPage from "pages/FreeDeliveryFullPage";

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });

    console.log("page_view fired", location.pathname);
  }, [location.pathname]);

  return null;
}

function UTMTracker() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    console.log(window.location.href);
    console.log(window.location.search);
    const utmData = {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
    };
    console.log("UTM Saved:", utmData);
    // save only first source
    if (utmData.utm_source && !localStorage.getItem("nuha_utm_data")) {
      localStorage.setItem("nuha_utm_data", JSON.stringify(utmData));

      console.log("UTM Saved:", utmData);
    } else {
      // No UTM in URL → clear old stored UTM
      localStorage.removeItem("nuha_utm_data");
      console.log("No UTM found, cleared storage");
    }
  }, []);

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        {/* <PageTracker /> */}
        <UTMTracker />
        <Routes>
          <Route path="/" exact element={<Dashboard />}></Route>
          <Route path="/home" exact element={<Dashboard />}></Route>
          <Route
            path="/category/:catalogueId"
            exact
            element={<CategoryWiseData />}
          />
          <Route
            path="/subCategory/:subCatalogueId"
            exact
            element={<SubCategoryWiseData />}
          />
          <Route path="/cart" exact element={<AddCartDetails />}></Route>
          <Route
            path="/details/:category/:id"
            exact
            element={<ProductDetails />}
          ></Route>
          <Route path="/orderDetails" exact element={<OrderDetails />}></Route>
          <Route
            path="/allNewProduct"
            exact
            element={<NewProductsFullPage />}
          ></Route>
          <Route
            path="/trendingProducts"
            exact
            element={<TrendingProductsFullPage />}
          ></Route>
          <Route
            path="/freeDeliveryProducts"
            exact
            element={<FreeDeliveryFullPage />}
          ></Route>
          <Route path="/hotOffer" exact element={<HotOffer />}></Route>
          <Route path="/confirmOrder" exact element={<ConfirmOrder />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
